import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@mui/material";

export default function App() {
  const [rows, setRows] = useState([...Array(40).keys()]);
  const loadMoreTrigger = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const target = entries[0];
        if (target.isIntersecting) {
          setRows((prev) => [
            ...prev,
            ...Array(30)
              .keys()
              .map((n) => n + prev.length)
          ]);
        }
      },
      { threshold: 1 }
    );

    if (loadMoreTrigger.current) observer.observe(loadMoreTrigger.current);
    return () => observer.disconnect();
  }, []);

  return (
    <Box
      sx={{
        width: 600,
        margin: "50px auto",
        fontFamily: "Arial"
      }}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>מספר</TableCell>
            <TableCell>תיאור</TableCell>
          </TableRow>
        </TableHead>
      </Table>

      <Box
        sx={{
          maxHeight: 350,
          overflowY: "auto",
          border: "1px solid #c8c8c8",
          borderRadius: "12px",
          mt: 1,
          pr: 1,
          scrollbarGutter: "stable"
        }}
      >
        <Table size="small">
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row}>
                <TableCell>{row}</TableCell>
                <TableCell>שורה מספר {row}</TableCell>
              </TableRow>
            ))}

            <tr ref={loadMoreTrigger}>
              <td style={{ height: 40 }}></td>
            </tr>
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
}
